// UserDialog.js
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Grid,
  Box,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const steps = [
  'Basic Information',
  'Organization Details',
  'Professional Information',
  'Memberships & Publications',
  'Financial Details',
  'Membership Information',
];

export default function StudentUserViewDialog({ open,user, onClose,userId })  {
 const [activeStep, setActiveStep] = useState(0);
 
   // Format date helper function
   const formatDate = (dateString) => {
     if (!dateString) return '';
     try {
       return new Date(dateString).toLocaleDateString();
     } catch (error) {
       return '';
     }
   };
 
   const handleNext = () => {
     setActiveStep((prevActiveStep) => prevActiveStep + 1);
   };
 
   const handleBack = () => {
     setActiveStep((prevActiveStep) => prevActiveStep - 1);
   };
 
   return (
     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
       <DialogTitle>View Life Member</DialogTitle>
       <DialogContent>
         <Stepper activeStep={activeStep} sx={{ my: 3 }}>
           {steps.map((label) => (
             <Step key={label}>
               <StepLabel>{label}</StepLabel>
             </Step>
           ))}
         </Stepper>
 
         {/* Basic Information */}
         {activeStep === 0 && (
           <Grid container spacing={2}>
             <Grid item xs={12}>
               <TextField 
                 label="Category"
                 value={user?.category || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField 
                 label="Name"
                 value={user?.name || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField 
                 label="Father/Husband Name"
                 value={user?.fatherOrHusbandName || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Address"
                 value={user?.address || ''}
                 fullWidth 
                 margin="normal"
                 multiline
                 rows={2}
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField 
                 label="Pin Code"
                 value={user?.pinCode || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField 
                 label="Gender"
                 value={user?.gender || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField
                 label="Phone Number"
                 value={user?.phoneNumber || ''}
                 fullWidth
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField 
                 label="Email"
                 value={user?.email || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField 
                 label="Date of Birth"
                 value={formatDate(user?.dateOfBirth)}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField 
                 label="Age"
                 value={user?.age || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
           </Grid>
         )}
 
         {/* Organization Details */}
         {activeStep === 1 && (
           <Grid container spacing={2}>
             <Grid item xs={12}>
               <TextField
                 label="Organization Name"
                 value={user?.organization?.name || ''}
                 fullWidth
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField
                 label="Organization Address"
                 value={user?.organization?.address || ''}
                 fullWidth
                 margin="normal"
                 multiline
                 rows={2}
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField
                 label="Organization Phone"
                 value={user?.organization?.phone || ''}
                 fullWidth
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12} md={6}>
               <TextField
                 label="Organization Mobile"
                 value={user?.organization?.mobile || ''}
                 fullWidth
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField
                 label="Organization Email"
                 value={user?.organization?.email || ''}
                 fullWidth
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Preferred Mailing Address"
                 value={user?.preferredMailingAddress || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Company Name"
                 value={user?.companyName || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Nature of Industry"
                 value={user?.natureOfIndustry || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Number of Employees"
                 value={user?.numberOfEmployees || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
           </Grid>
         )}
 
         {/* Professional Information */}
         {activeStep === 2 && (
           <Grid container spacing={2}>
             <Grid item xs={12}>
               <TextField 
                 label="Qualification"
                 value={user?.qualification || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Current Designation"
                 value={user?.currentDesignation || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Experience (Years)"
                 value={user?.experienceYears || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="LinkedIn ID"
                 value={user?.linkedInId || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             
             <Grid item xs={12}>
               <Typography variant="h6" gutterBottom>Past Experience</Typography>
               {user?.pastExperience && user.pastExperience.length > 0 ? (
                 <List>
                   {user.pastExperience.map((exp, index) => (
                     <ListItem key={index} divider sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                       <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                         <Typography variant="subtitle2">
                           {formatDate(exp.from)} - {formatDate(exp.to)}
                         </Typography>
                         <Typography variant="subtitle1" fontWeight="bold">
                           {exp.designation || ''}
                         </Typography>
                       </Box>
                       <Typography variant="body2">{exp.details || ''}</Typography>
                     </ListItem>
                   ))}
                 </List>
               ) : (
                 <Typography variant="body2" color="text.secondary">No past experience records</Typography>
               )}
             </Grid>
             
             <Grid item xs={12}>
               <TextField 
                 label="Additional Info"
                 value={user?.additionalInfo || ''}
                 fullWidth 
                 margin="normal"
                 multiline
                 rows={3}
                 disabled
               />
             </Grid>
           </Grid>
         )}
 
         {/* Memberships & Publications */}
         {activeStep === 3 && (
           <Grid container spacing={2}>
             <Grid item xs={12}>
               <Typography variant="h6" gutterBottom>Papers Published</Typography>
               {user?.papersPublished && user.papersPublished.length > 0 ? (
                 <List>
                   {user.papersPublished.map((paper, index) => (
                     <ListItem key={index} divider sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                       <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                         <Typography variant="subtitle1" fontWeight="bold">
                           {paper.title || ''}
                         </Typography>
                         <Typography variant="subtitle2">
                           {formatDate(paper.date)}
                         </Typography>
                       </Box>
                       <Typography variant="body2"><strong>Occasion:</strong> {paper.occasion || ''}</Typography>
                       <Typography variant="body2"><strong>Remarks:</strong> {paper.remarks || ''}</Typography>
                     </ListItem>
                   ))}
                 </List>
               ) : (
                 <Typography variant="body2" color="text.secondary">No papers published</Typography>
               )}
             </Grid>
             
             <Grid item xs={12} sx={{ mt: 3 }}>
               <Typography variant="h6" gutterBottom>Memberships</Typography>
               {user?.memberships && user.memberships.length > 0 ? (
                 <List>
                   {user.memberships.map((membership, index) => (
                     <ListItem key={index} divider sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                       <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                         <Typography variant="subtitle1" fontWeight="bold">
                           {membership.institution || ''}
                         </Typography>
                         <Typography variant="subtitle2">
                           {membership.category || ''}
                         </Typography>
                       </Box>
                       <Typography variant="body2"><strong>Professional Remarks:</strong> {membership.professionalRemarks || ''}</Typography>
                       <Typography variant="body2"><strong>Social Service Category:</strong> {membership.socialServiceCategory || ''}</Typography>
                       <Typography variant="body2"><strong>Remarks:</strong> {membership.remarks || ''}</Typography>
                     </ListItem>
                   ))}
                 </List>
               ) : (
                 <Typography variant="body2" color="text.secondary">No memberships</Typography>
               )}
             </Grid>
             
             <Grid item xs={12} sx={{ mt: 3 }}>
               <Typography variant="h6" gutterBottom>Introduced By</Typography>
               {user?.introducedBy?.name ? (
                 <Box sx={{ pl: 2 }}>
                   <Typography><strong>Name:</strong> {user.introducedBy.name}</Typography>
                   <Typography><strong>Membership Certificate Number:</strong> {user.introducedBy.membershipCertificateNumber || 'N/A'}</Typography>
                 </Box>
               ) : (
                 <Typography variant="body2" color="text.secondary">No introduction information</Typography>
               )}
             </Grid>
           </Grid>
         )}
 
         {/* Financial Details */}
         {activeStep === 4 && (
           <Grid container spacing={2}>
             <Grid item xs={12}>
               <TextField 
                 label="Payment Details"
                 value={user?.paymentdetails || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="MSME Certificate"
                 value={user?.MSMECertificate || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="PAN Number"
                 value={user?.panNumber || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
           </Grid>
         )}
 
         {/* Membership Information */}
         {activeStep === 5 && (
           <Grid container spacing={2}>
             <Grid item xs={12}>
               <TextField 
                 label="Membership ID"
                 value={user?.membershipID || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Membership Category"
                 value={user?.membershipCategory || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField 
                 label="Tenure"
                 value={user?.tenure || ''}
                 fullWidth 
                 margin="normal"
                 disabled
               />
             </Grid>
             <Grid item xs={12}>
               <TextField
                 label="How did you know about us?"
                 value={user?.howDidYouKnowAboutUs || ''}
                 fullWidth
                 margin="normal"
                 disabled
               />
             </Grid>
           </Grid>
         )}
       </DialogContent>
       <DialogActions>
         {activeStep > 0 && (
           <Button onClick={handleBack}>Back</Button>
         )}
         
         {activeStep < steps.length - 1 && (
           <Button onClick={handleNext}>Next</Button>
         )}
         
         <Button onClick={onClose}>Close</Button>
       </DialogActions>
     </Dialog>
   );
 }